






























import MoominLink from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue";
import { imagePlaceholderProduct } from "~/common";
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "MoominCategoryCard",
  components: { MoominLink },
  props: {
    label: {
      type: String,
      default: "",
    },
    image: {
      type: Object,
      default: () => ({
        desktop: imagePlaceholderProduct,
        mobile: imagePlaceholderProduct,
        thumbnail: imagePlaceholderProduct,
        alt: "image",
      }),
    },
    link: {
      type: String,
      default: "",
    },
    backgroundLabel: {
      type: String,
      default: "var(--c-secondary)",
    },
  },
});
